<template>
  <div class="gx-sku-pagination">
    <el-pagination
      class="gx-sku-pagination__pages"
      :current-page="page"
      :page-size="limit"
      :pager-count="7"
      :total="total"
      layout="prev, pager, next"
      @current-change="handlePageChange"
    />
    <div class="gx-sku-pagination__meta">
      <span>前往</span>
      <el-input
        :value="jumpPage"
        class="gx-sku-pagination__jump"
        size="mini"
        @input="jumpPage = $event"
        @keyup.enter.native="submitJump"
      />
      <span>页</span>
      <span>共{{ total }}条</span>
      <el-select :value="limit" class="gx-sku-pagination__size" size="mini" @change="handleLimitChange">
        <el-option v-for="size in pageSizes" :key="size" :label="`${size}条/页`" :value="size" />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkuListPagination',
  props: {
    total: { type: Number, required: true },
    page: { type: Number, default: 1 },
    limit: { type: Number, default: 20 },
    pageSizes: { type: Array, default: () => [10, 20, 50, 100, 200, 300, 400] }
  },
  data() {
    return { jumpPage: this.page }
  },
  watch: {
    page(value) {
      this.jumpPage = value
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.limit))
    }
  },
  methods: {
    handlePageChange(page) {
      this.emitPagination(page, this.limit)
    },
    handleLimitChange(limit) {
      this.emitPagination(1, limit)
    },
    submitJump() {
      this.emitPagination(Number(this.jumpPage), this.limit)
    },
    emitPagination(page, limit) {
      const targetPage = Math.min(this.totalPages, Math.max(1, Number.isFinite(page) ? Math.trunc(page) : 1))
      this.jumpPage = targetPage
      this.$emit('pagination', { page: targetPage, limit })
    }
  }
}
</script>

<style scoped>
.gx-sku-pagination {
  width: 100%;
  padding-top: 8px;
}
.gx-sku-pagination__pages {
  display: flex;
  justify-content: center;
  padding: 0;
  white-space: nowrap;
}
.gx-sku-pagination__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 8px;
  color: #6A6A8A;
  font-size: 11px;
  line-height: 24px;
}
.gx-sku-pagination__jump {
  width: 38px;
}
.gx-sku-pagination__size {
  width: 80px;
}
.gx-sku-pagination__size :deep(.el-input__inner ){
  padding-left: 10px;
  padding-right: 10px;
}
@media (max-width: 420px) {
  .gx-sku-pagination__meta {
    gap: 4px;
  }
}
</style>
